export const TIME_LEFT_TO_REFRESH_TOKEN = 60 * 60 * 24 * 30 // 30 days
